import { PropTypes } from 'prop-types';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import InputMask from 'react-input-mask';

const Datepicker = ({
  id,
  model,
  value,
  isRequired,
  isReadonly,
  changeEvt,
  blurEvt,
}) => {
  const [dateFocusOn, setDateFocusOn] = useState(false);

  const onDateFocus = () => {
    setDateFocusOn(true);
  };

  const onDateBlur = () => {
    setDateFocusOn(false);
    if (blurEvt && typeof blurEvt === 'function') {
      blurEvt();
    }
  };

  const onDateChange = date => {
    if (!date) return;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${year}${month}${day}`;
    if (changeEvt) {
      changeEvt(model, formattedDate);
    }
  };

  const makeStringToDate = dateString => {
    if (!dateString) return null;

    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);

    return new Date(`${year}-${month}-${day}`);
  };

  return (
    <DatePicker
      id={id}
      selected={value[model] ? makeStringToDate(value[model]) : null} // 기본값 제거
      className="form-control sm"
      dateFormat={dateFocusOn ? 'yyyyMMdd' : 'yyyy-MM-dd'}
      required={isRequired}
      readOnly={isReadonly}
      disabled={isReadonly}
      onChange={onDateChange}
      onFocus={onDateFocus}
      onBlur={onDateBlur}
      customInput={<InputMask aria-label={id} mask={'9999-99-99'}/>}
    />
  );
};

DatePicker.propTypes = {
  id: PropTypes.string,
  model: PropTypes.string.isRequired,
  value: PropTypes.object,
  isRequired: PropTypes.bool.isRequired,
  isReadonly: PropTypes.bool.isRequired,
  changeEvt: PropTypes.func.isRequired,
  blurEvt: PropTypes.func,
};

export default Datepicker;
